import React from 'react'
import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import Icon from '@dustin-web/microsite-components/src/icon'

const Benefits = () => {
  const { translate } = useTranslations()

  return (
    <div>
      <div className="u-px-16 u-radius-4">
        <h3>{translate('RegisterBuinsess_Usp_B2B_Headline')}</h3>
        <div className="d-flex align-items-center u-py-8 u-fw-bold u-color-dark-gray">
          <Icon name="bargain" className="u-mr-16 i-24" />
          <span>{translate('RegisterBuinsess_Usp_B2B_One')}</span>
        </div>
        {/* will be in use when we have a guide for attest
            <div className="d-flex align-items-center u-py-8 u-fw-bold u-color-dark-gray reg-thumbs">
              <Icon name="thumbs" className="u-mr-16 i-24" />
              <span>{translate('RegisterBuinsess_Usp_B2B_Two')}</span>
            </div> */}
        <div className="d-flex align-items-center u-py-8 u-fw-bold u-color-dark-gray">
          <Icon name="pen" className="u-mr-16 i-24" />
          <span>{translate('RegisterBuinsess_Usp_B2B_Three')}</span>
        </div>
        <div className="d-flex align-items-center u-py-8 u-fw-bold u-color-dark-gray">
          <Icon name="computer" className="u-mr-16 i-24" />
          <span>{translate('RegisterBuinsess_Usp_B2B_Four')}</span>
        </div>
      </div>
    </div>
  )
}

export default Benefits
